// extracted by mini-css-extract-plugin
export default {"tabLabel":"ccf-reporting_tabLabel__NnQId"};